class SearchActiveFilters {
  constructor(context, settings, $) {
    console.log("SearchActiveFilters");
    this.$ = $;
    this.element = document.querySelector(".c-search-active-filters");

    if (this.element === null) {
      return;
    }

    const parentForm = this.element.closest("form");
    const activeFilters = document.querySelectorAll(".c-active-filter");

    activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener("click", () => {
        if (parentForm) {
          setTimeout(() => {
            parentForm.submit();
          }, 500);
        }
      });
    });
  }
}

export default SearchActiveFilters;
